import React from 'react';
// @ts-ignore
import GaugeChart from 'react-gauge-chart'

import styles from './styles.module.css';
import {
    determinePollutionLabel,
    determinePollutionLabelBUA,
    getPollutantLabel,
    QUALITY_CLASSIFICATION,
    QUALITY_CLASSIFICATION_FIVE_LEVEL
} from "../../helper/airQualityHelper";
import moment from "moment";
import {AQIPollution, GaugeLevelMode} from "../../types/common.types";
import {useTranslation} from "react-i18next";

type AirQualityGaugeProps = {
    aqiPollution: AQIPollution;
    gaugeLevel: GaugeLevelMode;
}

const AirQualityGauge = ({
                             aqiPollution,
                             gaugeLevel
                         }: AirQualityGaugeProps) => {

    const {t} = useTranslation();
    const arcsLength = gaugeLevel === GaugeLevelMode.FIVE ? 1 / 5 : 1 / 6;
    const arcsLengthArray = gaugeLevel === GaugeLevelMode.FIVE ? [arcsLength, arcsLength, arcsLength, arcsLength, arcsLength] : [arcsLength, arcsLength, arcsLength, arcsLength, arcsLength, arcsLength];
    const colorArray = gaugeLevel === GaugeLevelMode.FIVE ? ['#67f948', '#9deb56', '#fde143', '#ff4242', '#960032'] : ['#67f948', '#9deb56', '#efff42', '#fde143', '#ff4242', '#960032'];
    const nrOfLevels = gaugeLevel === GaugeLevelMode.FIVE ? 5 * 70 : 6 * 70;

    const determinePollutionValue = (indexLevel: string) => {

        if (gaugeLevel === GaugeLevelMode.SIX) {
            switch (indexLevel) {
                case QUALITY_CLASSIFICATION.EXTREMELY_POOR:
                    return (5 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION.VERY_POOR:
                    return (4 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION.POOR:
                    return (3 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION.MODERATE:
                    return (2 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION.FAIR:
                    return (arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION.GOOD:
                    return (arcsLength / 2);
            }
        }

        if (gaugeLevel === GaugeLevelMode.FIVE) {
            switch (indexLevel) {
                case QUALITY_CLASSIFICATION_FIVE_LEVEL.VERY_POOR:
                    return (4 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION_FIVE_LEVEL.POOR:
                    return (3 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION_FIVE_LEVEL.MODERATE:
                    return (2 * arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION_FIVE_LEVEL.GOOD:
                    return (arcsLength) + (arcsLength / 2);
                case QUALITY_CLASSIFICATION_FIVE_LEVEL.VERY_GOOD:
                    return (arcsLength / 2);
            }
        }
    }

    const aqiLevelDescription = gaugeLevel === GaugeLevelMode.FIVE ?
        <h3> {determinePollutionLabelBUA(aqiPollution.majorIndexLevel)}</h3> :
        <h3> {determinePollutionLabel(aqiPollution.majorIndexLevel)}</h3>;
    const majorPollutantLabel =
        <span>{t('AirQualityGauge.label-major-pollutant')}: {getPollutantLabel(aqiPollution.majorPollutant)}</span>;
    const aqiMeasureDate = aqiPollution.measuringDate ? <span> {t('AirQualityGauge.label-calculated-at', {
        calculatedAt: moment(aqiPollution.measuringDate).format('Do MMMM YYYY · HH:mm')
    })}</span> : null;

    return (
        <div className={styles.gaugeDiagramm}>
            <GaugeChart id={'gauge-chart-aqi'}
                        animate={false}
                        nrOfLevels={nrOfLevels}
                        arcsLength={arcsLengthArray}
                        colors={colorArray}
                        hideText={true}
                        percent={determinePollutionValue(aqiPollution.majorIndexLevel)}
                        arcPadding={0.02}
                        needleColor={'#000000'}
                        needleBaseColor={'#000000'}
                        cornerRadius={2}
                        style={{width: 300}}/>
            {aqiLevelDescription}
            {majorPollutantLabel}
            <br/>
            <span>{aqiMeasureDate}</span>
        </div>
    );
}

export default AirQualityGauge;